/**
 * Interface contract for Biometric and Passkey Providers.
 * Universal device-agnostic interface supporting WebAuthn, Windows Hello,
 * and future external biometric scanner hardware adapters.
 */
export class IBiometricProvider {
  /**
   * Checks if this provider is available and supported on the current device/browser.
   * @returns {Promise<boolean>}
   */
  async isAvailable() {
    throw new Error('isAvailable() must be implemented by provider.');
  }

  /**
   * Retrieves friendly device and platform information.
   * @returns {Promise<{ providerName: string, deviceType: string, supportsBiometrics: boolean }>}
   */
  async getDeviceInfo() {
    throw new Error('getDeviceInfo() must be implemented by provider.');
  }

  /**
   * Performs credential registration ceremony.
   * @param {object} serverOptions - WebAuthn CredentialCreationOptions from server
   * @returns {Promise<object>} Serialized attestation response for server validation
   */
  async register(serverOptions) {
    throw new Error('register() must be implemented by provider.');
  }

  /**
   * Performs credential authentication ceremony.
   * @param {object} serverOptions - WebAuthn AssertionOptions from server
   * @returns {Promise<object>} Serialized assertion response for server validation
   */
  async authenticate(serverOptions) {
    throw new Error('authenticate() must be implemented by provider.');
  }
}

export default IBiometricProvider;
